import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Icon, { GLYPHS } from '../../../../common/icon';
import Dropdown from '../../../../common/Dropdown';
import { useClickOutside } from '../../../../../modules/infra/small-tools/use-click-outside';

const AddTranslationButton = ({ languages, onAdd }) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useClickOutside(dropdownRef, () => {
    setTimeout(() => {
      if (isOpen) {
        setIsOpen(false);
      }
    }, 200);
  });

  return (
    <button className="c-localization-tabs__tab" type="button" onClick={() => setIsOpen(!isOpen)} ref={dropdownRef}>
      <Icon glyph={GLYPHS.plusSign} size="micro" />
      <div className="c-localization-tabs__dropdown">
        <Dropdown alignment="bottom">
          {isOpen &&
            languages.map((language) => (
              <Dropdown.Item
                key={language.value}
                onClick={() => {
                  onAdd?.(language);
                  setIsOpen(false);
                }}
              >
                <div className="c-localization-tabs__dropdown-item">{language.description}</div>
              </Dropdown.Item>
            ))}
        </Dropdown>
      </div>
    </button>
  );
};

AddTranslationButton.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.object),
  onAdd: PropTypes.func,
};

AddTranslationButton.defaultProps = {
  languages: [],
  onAdd: noop,
};

export default AddTranslationButton;
